import { render, staticRenderFns } from "./CategorySetDialog.vue?vue&type=template&id=4def0d39"
import script from "./CategorySetDialog.js?vue&type=script&lang=js&external"
export * from "./CategorySetDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports